import { useNavigation } from 'react-router'

export const SubmitTrigger = ({ label = 'Register >' }) => {
  const navigation = useNavigation()
  const isSubmitting = navigation.state === 'submitting'

  return (
    <button
      type="submit"
      disabled={isSubmitting}
      className="mr-4 rounded-full bg-primary-blue px-6 py-2 text-2xl text-slate-50 transition-colors duration-300 hover:bg-[#2a60de] print:hidden"
    >
      {isSubmitting ? 'Submitting...' : label}
    </button>
  )
}
